module.exports = __webpack_public_path__ + "img/ic_photo.bf0ac6f0.svg";